import {
  uploadDirectoriesWithFiles,
  uploadDocumentations,
} from 'services/documentationUpload';
import { assignFilesToDirectoriesModel } from './model';
import {
  DocumentationUploadService,
  DocumentationUploadServiceDependencies,
} from './types';

const defaultDependencies: DocumentationUploadServiceDependencies = {
  uploadDocumentations,
  uploadDirectoriesWithFiles,
};

export function createDocumentationUploadService(
  dependencies: DocumentationUploadServiceDependencies = defaultDependencies
): DocumentationUploadService {
  return {
    uploadDocumentations: dependencies.uploadDocumentations,
    uploadDirectoriesWithFiles: dependencies.uploadDirectoriesWithFiles,
    assignFilesToDirectories: async (
      files,
      directoriesMap,
      config
    ): Promise<void> => {
      await assignFilesToDirectoriesModel({
        files,
        directoriesMap,
        config,
      });
    },
  };
}

export type {
  AssignFilesToDirectoriesInput,
  DocumentationUploadService,
  DocumentationUploadServiceDependencies,
} from './types';
